import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export enum EnrollmentDisplayVersionEnum {
  SHORT = 'SHORT',
  LONG = 'LONG'
}

export function getDisplayVersion(
  enrollmentId: number
): Promise<{ version: EnrollmentDisplayVersionEnum }> {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getDisplayVersion.url, { id: enrollmentId }))
    .get<{ version: EnrollmentDisplayVersionEnum }>()
}
